// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__3wS7m","right":"styles_right__X8p25"};